export default __webpack_public_path__ + "static/media/calvin.df13555a.png";